import React from 'react';
import { Redirect } from 'react-router-dom';
import useApp from '../store/app/appContext';
import PrivateRoute from './PrivateRoute';

function PatientRoute({
  component,
  path
}) {
  
  const { appState: { user } } = useApp();

  if (user.user_type === 'patient' || user.user_type === 'temp') return (
    <PrivateRoute component={component} path={path}/>
  )
  
  return <Redirect to='/dashboard'/>
  
}

export default PatientRoute;
